import React from  'react';
import { withPrefix } from "gatsby";
import { Router } from "@reach/router";
import PrivateRoute from '../../components/Utils/PrivateRoute';
import Chime from '../../components/chime';
import PartnerOne from '../../components/partnerOne';
import Partnerships from '../../components/partnerships';
import Login from '../../components/Login/Login'

const index = () => {
  return (
    <Router basepath={withPrefix("/partners/")}>
      <PrivateRoute path="partnerOne" component={PartnerOne}/>
      <PrivateRoute path="our-work" component={Partnerships}/>
      <PrivateRoute path="chime" component={Chime}/>
      <Login path="login" component={Login} default/>
    </Router>
  )
}

export default index
